"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7590],{

/***/ 2491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ ApplySchema; }
/* harmony export */ });
/* unused harmony exports toSafeJsonLd, InternalSchema */
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2222);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



/**
 * Serializa o schema em JSON-LD escapando `<`, `>` e `&` como \uXXXX. Impede que um valor
 * com `</script>` (ex.: bio de autor vinda do CMS) feche o <script> antes da hora e injete
 * HTML na página. O JSON continua válido — os escapes voltam ao caractere ao parsear.
 */ function toSafeJsonLd(schema) {
    return JSON.stringify(schema).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026");
}
function InternalSchema(param) {
    var schema = param.schema;
    var schemaUse = schema;
    if (!schemaUse) return null;
    switch(schemaUse["@type"]){
        case "BreadcrumbList":
            schemaUse["@id"] = "https://canaltech.com.br/#breadcrumb";
            break;
        case "Article":
            if (schemaUse === null || schemaUse === void 0 ? void 0 : schemaUse.datePublished) {
                schemaUse["@type"] = "NewsArticle";
            }
            schemaUse.publisher["@id"] = "https://canaltech.com.br/#organization";
            break;
        case "CollectionPage":
            schemaUse["@id"] = "https://canaltech.com.br/#webpage";
            schemaUse.isPartOf["@id"] = "https://canaltech.com.br/#website", schemaUse.primaryImageOfPage["@id"] = "https://canaltech.com.br/#primaryimage";
            schemaUse.image["@id"] = "https://canaltech.com.br/#primaryimage";
            schemaUse.breadcrumb["@id"] = "https://canaltech.com.br/#breadcrumb";
        default:
            break;
    }
    if (!schemaUse["@context"]) {
        schemaUse["@context"] = "http://schema.org";
    }
    if ("author" in schemaUse && !schemaUse.publisher) {
        schemaUse.publisher = {
            "@type": "Organization",
            "@id": "https://canaltech.com.br/#organization",
            name: "Canaltech",
            logo: {
                "@type": "ImageObject",
                url: "https://img.canaltech.com.br/logo-ct.png"
            }
        };
    }
    // eslint-disable-next-line react/no-danger
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        type: "application/ld+json",
        className: typeof schema === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(schema),
        dangerouslySetInnerHTML: {
            __html: toSafeJsonLd(schemaUse)
        }
    });
}
var ApplySchema = function(param) {
    var schema = param.schema;
    var applySchema = schema;
    if (!applySchema.website) {
        applySchema.website = {
            "@type": "WebSite",
            "@id": "https://canaltech.com.br/#website",
            name: "Canaltech",
            url: "https://canaltech.com.br",
            description: "Tecnologia pra quem entende",
            alternateName: "CT",
            inLanguage: "pt-BR",
            potentialAction: {
                "@type": "SearchAction",
                target: "https://canaltech.com.br/busca/?q={search_term_string}",
                "query-input": "required name=search_term_string"
            }
        };
    }
    if (!applySchema.organization) {
        applySchema.organization = {
            "@type": "NewsMediaOrganization",
            "@id": "https://canaltech.com.br/#organization",
            url: "https://canaltech.com.br",
            logo: {
                "@type": "ImageObject",
                url: "https://img.canaltech.com.br/canaltech-512.png",
                width: "512",
                height: "512"
            },
            name: "Canaltech",
            sameAs: [
                "https://facebook.com/canaltech",
                "https://twitter.com/canaltech",
                "https://www.tiktok.com/canaltech",
                "https://www.youtube.com/canaltech",
                "https://www.youtube.com/c/MaravilhasdaTecnologia",
                "https://pt.wikipedia.org/wiki/Canaltech",
                "https://www.linkedin.com/company/canaltech-brasil",
                "https://www.instagram.com/canaltech",
                "https://flipboard.com/@canaltech",
                "https://t.me/Canaltech_Oficial",
                "https://t.me/ctofertas", 
            ],
            alternateName: "CT",
            address: {
                "@id": "https://canaltech.com.br/#local-main-place-address",
                "@type": "PostalAddress",
                streetAddress: "Rua Maria Prestes Maia, 300",
                addressLocality: "S\xe3o Paulo",
                postalCode: "02047000",
                addressRegion: "SP",
                addressCountry: "BR"
            }
        };
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: Object.values(applySchema).map(function(schemaItem, index) {
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InternalSchemaMemo, {
                schema: schemaItem
            }, index));
        })
    });
};
var InternalSchemaMemo = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(InternalSchema, function() {
    return true;
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InternalSchemaMemo)));


/***/ }),

/***/ 7590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./src/utils/className.ts
var utils_className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Layout/Top/index.tsx



function Propaganda(param) {
    var Ads = param.Ads, whiteBg = param.whiteBg, center = param.center, _shouldHaveAds = param.shouldHaveAds, shouldHaveAds = _shouldHaveAds === void 0 ? true : _shouldHaveAds;
    var ref;
    var variants = {
        TopoContainer: {
            center: {
                true: "center [&.center]:h-[initial]",
                false: ""
            },
            whiteBg: {
                true: "whiteBg [&.whiteBg]:bg-mglGray50",
                false: ""
            }
        }
    };
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var topSpan = currentSpan && currentSpan.startChild({
        op: "top"
    });
    return !Ads ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,utils_className/* default */.Z)("flex h-[100px] flex-col items-center justify-center bg-mglGray100 desktop:h-[250px]", whiteBg != undefined && variants.TopoContainer.whiteBg[whiteBg.toString()], center != undefined && variants.TopoContainer.center[center.toString()]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-auto w-full items-center justify-center text-sm uppercase text-mglGray500",
                children: shouldHaveAds ? "Publicidade" : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: topSpan && topSpan.finish()
            })
        ]
    }) : null;
}

// EXTERNAL MODULE: ./src/components/Layout/PageWrapperMenu/styles.tsx
var styles = __webpack_require__(9484);
// EXTERNAL MODULE: ./src/components/Layout/GlobalContainer/index.tsx
var GlobalContainer = __webpack_require__(7970);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Layout/Headers/index.tsx
/* eslint-disable no-prototype-builtins */ /* eslint-disable react/jsx-fragments */ /* eslint-disable react/no-array-index-key */ 



function HeadersPage(param) {
    var headPage = param.headPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: "Canaltech"
            }),
            headPage && headPage.map(function(page, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        page.tag === "title" ? /*#__PURE__*/ (0,react.createElement)(page.tag, (0,_object_spread/* default */.Z)({
                            key: index
                        }, page.attr), page.content) : /*#__PURE__*/ (0,react.createElement)(page.tag, (0,_object_spread/* default */.Z)({
                            key: index
                        }, page.attr)),
                        page.tag === "meta" && page.attr.hasOwnProperty("http-equiv") && /*#__PURE__*/ (0,react.createElement)(page.tag, {
                            key: index,
                            httpEquiv: "Cache-control",
                            content: page.attr.content
                        })
                    ]
                }, index);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/hooks/useBackground.ts

function useBackground() {
    var PropagandaActive = (0,react.useRef)(false);
    var backgroundName = (0,react.useRef)("");
    var hasAdvertisingActive = (0,react.useCallback)(function(event) {
        if (typeof event.data === "object" && "background" in event.data) {
            backgroundName.current = event.data.background;
            if (backgroundName.current === "bg-samsung-linhaz-popup") {
                var externalAdScript = document.createElement("script");
                externalAdScript.src = "https://assets.canaltech.com.br/js/11d2412/samsung.js";
                externalAdScript.async = true;
                document.body.insertBefore(externalAdScript, document.body.firstChild);
            }
            PropagandaActive.current = true;
        }
    }, []);
    (0,react.useEffect)(function() {
        window.addEventListener("message", hasAdvertisingActive, false);
        return function() {
            window.removeEventListener("message", hasAdvertisingActive, true);
        };
    }, [
        hasAdvertisingActive
    ]);
    return {
        isAdActive: PropagandaActive.current,
        adName: backgroundName.current
    };
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/hooks/usePageViewComscoreRequest.ts



var publicRuntimeConfig = config_default()().publicRuntimeConfig;
function usePageviewConscoreRequest() {
    var publicUrl = publicRuntimeConfig.NEXT_PUBLIC_URL;
    var randomHash = Math.random().toString(36).substring(7);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", handlerPageViewComscoreRequest);
        return function() {
            router.events.off("routeChangeComplete", handlerPageViewComscoreRequest);
        };
    }, []);
    var handlerPageViewComscoreRequest = function() {
        if (true) {
            fetch("".concat(publicUrl, "/pageview_candidate.txt?pr=").concat(randomHash), {
                method: "GET"
            }).then(function(response) {
                if (!response.ok) {
                    throw new Error("HTTP error! status: ".concat(response.status));
                }
            });
        }
    };
}

;// CONCATENATED MODULE: ./src/hooks/usePageViewComscoreScript.ts

function usePageviewConscoreScript() {
    (0,react.useEffect)(function() {
        var self = window;
        if (self.COMSCORE) {
            self.COMSCORE.beacon({
                c1: "2",
                c2: "20572948",
                options: {
                    enableFirstPartyCookie: true,
                    bypassUserConsentRequirementFor1PCookie: true
                }
            });
        }
    }, []);
}

// EXTERNAL MODULE: ./src/components/Layout/Banner/index.tsx + 6 modules
var Banner = __webpack_require__(9250);
// EXTERNAL MODULE: ./src/components/Internals/InternalSchema/index.tsx
var InternalSchema = __webpack_require__(2491);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./src/hooks/useScriptFlag.ts
var useScriptFlag = __webpack_require__(1436);
;// CONCATENATED MODULE: ./src/components/Ads/CazambaAds/index.tsx





// @refresh reset
function CazambaAds() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("phone"), 1), isMobile = ref[0];
    var hasRendered = (0,react.useRef)(false);
    var shouldRenderAds = (0,useScriptFlag/* default */.Z)({
        adFlag: "cazamba"
    });
    var appendScript = function() {
        if (hasRendered.current) return;
        var existingComponent = document.getElementById("cazambaPos");
        if (!existingComponent) return;
        var existingScript = document.getElementById("cazamba");
        if (existingScript) return;
        var script = document.createElement("script");
        script.id = "cazamba";
        script.setAttribute("cfasync", "false");
        script.setAttribute("delayedSrc", "https://api.cazamba.com/367defddd45f62f92c247bb37f37f181.js");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        var cazambaParent = document.getElementById("cazambaPos");
        cazambaParent.appendChild(script);
        hasRendered.current = true;
        setTimeout(function() {
            script.setAttribute("src", script.getAttribute("delayedSrc"));
        }, 5000);
    };
    (0,react.useEffect)(function() {
        if (shouldRenderAds) appendScript();
    }, []);
    if (isMobile) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "cazambaPos",
        className: "cazambaPos"
    });
}

// EXTERNAL MODULE: ./src/components/Ads/Google/AdsTypeGeneratorsMemo/index.tsx
var AdsTypeGeneratorsMemo = __webpack_require__(9831);
// EXTERNAL MODULE: ./src/hooks/useScriptsToRoute.ts
var useScriptsToRoute = __webpack_require__(5923);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/assets/svg/ctlogo.svg
var ctlogo = __webpack_require__(3535);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/components/Navbar/styles.tsx





var variants = {
    NavBarContainer: {
        menuStatus: {
            true: "left-0",
            false: "left-[-60px] tablet:left-0"
        }
    },
    MenuAction: {
        isActive: {
            true: "bg-titleBlack rounded-half cursor-pointer [&_svg]:fill-mglGray50 [&_svg]:transition-[fill] [&_svg]:duration-[400ms] [&_svg]:ease-in-out",
            false: "[&_svg]:fill-mglGray50/40"
        }
    },
    MenuSuspenso: {
        menuStatus: {
            true: "left-[60px]",
            false: "left-[-280px]"
        }
    }
};
var Cabecalho = function(_param) {
    var children = _param.children, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("fixed left-0 right-0 top-0 z-[9998] flex h-[60px] w-full items-center justify-center overflow-auto bg-mglGray900 tablet:w-[60px] tablet:overflow-hidden [&_button]:absolute [&_button]:left-[18px] [&_button]:top-[21px] [&_button]:flex [&_button]:cursor-pointer [&_button]:border-0 [&_button]:bg-transparent tablet:[&_button]:hidden [&_div]:h-[unset] [&_div]:w-[unset] [&_div]:overflow-auto tablet:[&_div]:h-10 tablet:[&_div]:w-10 tablet:[&_div]:overflow-hidden", className)
    }, rest), {
        children: children
    }));
};
var NavBarContainer = function(_param) {
    var children = _param.children, className = _param.className, menuStatus = _param.menuStatus, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "menuStatus"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("fixed bottom-0 left-0 top-[60px] z-[1001] flex h-[calc(100%-60px)] w-[60px] flex-col items-center justify-between bg-mglGray900 transition-[left] duration-300 ease-ease [&_ul]:flex [&_ul]:w-10 [&_ul]:flex-col [&_ul]:items-center [&_ul]:justify-center [&_ul]:px-[10px] [&_ul]:pb-[10px] [&_ul]:pt-0 [&_ul]:last:w-[60px]", variants.NavBarContainer.menuStatus[menuStatus.toString()], className)
    }, rest), {
        children: children
    }));
};
var MenuAction = function(_param) {
    var children = _param.children, className = _param.className, isActive = _param.isActive, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "isActive"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("relative flex h-10 w-10 items-center justify-center hover:cursor-pointer hover:rounded-half hover:bg-titleBlack [&_span]:absolute [&_span]:right-1 [&_span]:top-2 [&_span]:h-[6px] [&_span]:w-[6px] [&_span]:rounded-half [&_span]:bg-[#0EFDC1] [&_svg]:h-6 [&_svg]:w-6 [&_svg]:transition-[fill] [&_svg]:duration-[400ms] [&_svg]:ease-in-out [&_svg]:hover:fill-mglGray50", variants.MenuAction.isActive[isActive.toString()], className)
    }, rest), {
        children: children
    }));
};
var NavBarMain = function(_param) {
    var children = _param.children, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("[@media_only_screen_and_(max-width:426px)]:[&+section]:mt-[60px]", className)
    }, rest), {
        children: children
    }));
};
var MenuSuspenso = function(_param) {
    var children = _param.children, className = _param.className, menuStatus = _param.menuStatus, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "menuStatus"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("menu-suspenso", variants.MenuSuspenso.menuStatus[menuStatus.toString()], className)
    }, rest), {
        children: children
    }));
};
var ListNavbar = function(_param) {
    var children = _param.children, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("list-navbar", className)
    }, rest), {
        children: children
    }));
};
var ListTitle = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "m-0 cursor-default px-4 pb-4 pt-0 text-base font-medium uppercase leading-4"
    }, rest), {
        children: children
    }));
};

// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Navbar/NavbarContentItem/index.tsx
/* eslint-disable no-prototype-builtins */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 




function NavbarContentItem(param) {
    var link = param.link, setOpen = param.setOpen, setOption = param.setOption;
    var targetProps = {};
    if (typeof link[1] === "object" && link[1].hasOwnProperty("target")) Object.assign(targetProps, {
        target: "_blank"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            typeof link[1] === "object" && link[1].hasOwnProperty("divisor") && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "navbar-divider"
            }),
            !link[1].hasOwnProperty("classe") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "list-item-navbar-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: typeof link[1] === "string" ? link[1] : link[1].url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        title: link[0]
                    }, targetProps), {
                        onClick: function() {
                            setOpen(false);
                            setOption(false);
                        },
                        rel: "noreferrer",
                        children: [
                            typeof link[1] === "object" && link[1].hasOwnProperty("icone") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "mdi:".concat(link[1].icone)
                            }),
                            link[0]
                        ]
                    }))
                })
            }, link[0]) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "cursor-default hover:bg-mglGray50 [&_span]:m-0 [&_span]:flex [&_span]:cursor-[unset] [&_span]:p-4 [&_span]:text-sm [&_span]:font-medium [&_span]:uppercase [&_span]:leading-[14px] [&_span]:text-black/80",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: link[0]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarContent/NewsTab/index.tsx



function NewsTab(param) {
    var isActive = param.isActive, newsTabData = param.newsTabData, setOpen = param.setOpen, setOption = param.setOption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListNavbar, {
        className: isActive && "show",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, {
                children: "Not\xedcias "
            }),
            Object.entries(newsTabData.links).map(function(link) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarContentItem, {
                    link: link,
                    setOpen: function(x) {
                        return setOpen(x);
                    },
                    setOption: function(x) {
                        return setOption(x);
                    }
                }, link[0]);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarContent/VideosTab/index.tsx



function VideosTab(param) {
    var isActive = param.isActive, newsTabVideos = param.newsTabVideos, setOpen = param.setOpen, setOption = param.setOption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListNavbar, {
        className: isActive && "show",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, {
                children: "V\xcdDEOS"
            }),
            Object.entries(newsTabVideos.links).map(function(link) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarContentItem, {
                    link: link,
                    setOpen: function(x) {
                        return setOpen(x);
                    },
                    setOption: function(x) {
                        return setOption(x);
                    }
                }, link[0]);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarContent/PodcastTab/index.tsx



function PodcastTab(param) {
    var isActive = param.isActive, newsTabPodcast = param.newsTabPodcast, setOpen = param.setOpen, setOption = param.setOption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListNavbar, {
        className: isActive && "show",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, {
                children: "PODCASTS "
            }),
            Object.entries(newsTabPodcast.links).map(function(link) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarContentItem, {
                    link: link,
                    setOpen: function(x) {
                        return setOpen(x);
                    },
                    setOption: function(x) {
                        return setOption(x);
                    }
                }, link[0]);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarContent/ProductsTab/index.tsx



function ProductsTab(param) {
    var isActive = param.isActive, newsTabProducts = param.newsTabProducts, setOpen = param.setOpen, setOption = param.setOption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListNavbar, {
        className: isActive && "show",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, {
                children: "PRODUTOS"
            }),
            Object.entries(newsTabProducts.links).map(function(link) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarContentItem, {
                    link: link,
                    setOpen: function(x) {
                        return setOpen(x);
                    },
                    setOption: function(x) {
                        return setOption(x);
                    }
                }, link[0]);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarContent/MoreCanaltechTab/index.tsx



function MoreCanaltech(param) {
    var isActive = param.isActive, newsTabMore = param.newsTabMore, setOpen = param.setOpen, setOption = param.setOption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListNavbar, {
        className: isActive && "show",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, {
                children: "MAIS CANALTECH "
            }),
            Object.entries(newsTabMore.links).map(function(link) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarContentItem, {
                    link: link,
                    setOpen: function(x) {
                        return setOpen(x);
                    },
                    setOption: function(x) {
                        return setOption(x);
                    }
                }, link[0]);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Navbar/NavbarContent/OfferTab/index.tsx



function OfferTab(param) {
    var isActive = param.isActive, newsTabOffer = param.newsTabOffer, setOpen = param.setOpen, setOption = param.setOption;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListNavbar, {
        className: isActive && "show",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTitle, {
                children: "CANALTECH OFERTAS"
            }),
            Object.entries(newsTabOffer.links).map(function(link) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarContentItem, {
                    link: link,
                    setOpen: function(x) {
                        return setOpen(x);
                    },
                    setOption: function(x) {
                        return setOption(x);
                    }
                }, link[0]);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Navbar/index.tsx
/* eslint-disable react/no-danger */ /* eslint-disable react/no-array-index-key */ /* eslint-disable no-prototype-builtins */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ 















var Navbar_publicRuntimeConfig = config_default()().publicRuntimeConfig;
function Navbar(param) {
    var navBarContent = param.navBarContent, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "span" : _headingTag, _mandatorySearch = param.mandatorySearch, mandatorySearch = _mandatorySearch === void 0 ? false : _mandatorySearch;
    var HandleMenuAction = function HandleMenuAction(option) {
        var itemMenu = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (itemMenu && option !== "Pr\xeamio Canaltech" && option !== optionName) {
            if (option !== "Busca") setOpen(true);
            setOption(option);
            return;
        }
        if (itemMenu && option === "Pr\xeamio Canaltech") {
            setOpen(false);
            router.push(itemMenu.link);
            return;
        }
        if (isOpen) {
            setOpen(false);
            setOption("");
        }
    };
    var HandleSearchSubmit = function HandleSearchSubmit(event) {
        event.preventDefault();
        var isValid = function() {
            return searchContent.trim().length > 0 && searchContent !== router.query.q;
        };
        if (isValid()) window.location.href = "/busca/?q=".concat(searchContent);
        setOpen(false);
        setOption("");
    };
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var navbarSpan = currentSpan && currentSpan.startChild({
        op: "navbar"
    });
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(""), optionName = ref2[0], setOption = ref2[1];
    var ref3 = (0,react.useState)(""), searchContent = ref3[0], setSearchContent = ref3[1];
    var router = (0,next_router.useRouter)();
    var titleCt = "Canaltech - Not\xedcias de Tecnologia, Ci\xeancia e Entretenimento";
    var Heading = headingTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarMain, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cabecalho, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            "aria-label": "Menu",
                            onClick: function() {
                                if (isOpen) {
                                    setOption("Not\xedcias");
                                    setOpen(false);
                                    return;
                                }
                                setOption("Not\xedcias");
                                setOpen(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: !isOpen ? "mdi:menu" : "mdi:close",
                                width: "24",
                                height: "24",
                                color: "rgb(255, 255, 255)"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                            id: "heading-title-logo",
                            className: "invisible hidden",
                            children: titleCt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(Navbar_publicRuntimeConfig.NEXT_PUBLIC_URL, "/"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: "P\xe1gina Principal do Canaltech",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ctlogo/* default */.Z, {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarContainer, {
                menuStatus: isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        Object.entries(navBarContent.top).map(function(link, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuAction, {
                                    onClick: function() {
                                        HandleMenuAction(link[0], link[1]);
                                    },
                                    isActive: optionName === link[0],
                                    dangerouslySetInnerHTML: {
                                        __html: "\n                ".concat(link[1].svg, "\n                ").concat(link[1].badge ? "<span/>" : "", "\n                ")
                                    }
                                })
                            }, index);
                        }),
                        Object.entries(navBarContent.bottom).map(function(link, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuAction, {
                                    onClick: function() {
                                        HandleMenuAction(link[0], link[1]);
                                    },
                                    isActive: optionName === index[0],
                                    dangerouslySetInnerHTML: {
                                        __html: "\n                ".concat(link[1].svg, "\n                ").concat(link[1].badge ? "<span/>" : "", "\n                ")
                                    }
                                })
                            }, index);
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed left-0 right-0 top-0 z-[1000] block h-screen bg-black/5 transition-all duration-300 ease-in-out",
                onClick: function() {
                    setOpen(false);
                    setOption("");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuSuspenso, {
                menuStatus: isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTab, {
                        newsTabData: navBarContent.top.Notícias,
                        isActive: optionName === "Not\xedcias",
                        setOpen: function(x) {
                            return setOpen(x);
                        },
                        setOption: function(x) {
                            return setOption(x);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideosTab, {
                        newsTabVideos: navBarContent.top.Vídeos,
                        isActive: optionName === "V\xeddeos",
                        setOpen: function(x) {
                            return setOpen(x);
                        },
                        setOption: function(x) {
                            return setOption(x);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PodcastTab, {
                        newsTabPodcast: navBarContent.top.Podcasts,
                        isActive: optionName === "Podcasts",
                        setOpen: function(x) {
                            return setOpen(x);
                        },
                        setOption: function(x) {
                            return setOption(x);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsTab, {
                        newsTabProducts: navBarContent.top.Produtos,
                        isActive: optionName === "Produtos",
                        setOpen: function(x) {
                            return setOpen(x);
                        },
                        setOption: function(x) {
                            return setOption(x);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreCanaltech, {
                        newsTabMore: navBarContent.top["Mais Canaltech"],
                        isActive: optionName === "Mais Canaltech",
                        setOpen: function(x) {
                            return setOpen(x);
                        },
                        setOption: function(x) {
                            return setOption(x);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferTab, {
                        newsTabOffer: navBarContent.top["Canaltech Ofertas"],
                        isActive: optionName === "Canaltech Ofertas",
                        setOpen: function(x) {
                            return setOpen(x);
                        },
                        setOption: function(x) {
                            return setOption(x);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,utils_className/* default */.Z)("fixed left-0 right-0 top-0 z-[1000] h-screen flex-col justify-center bg-mglGray900 transition-all duration-300 ease-in-out [&.showMenu]:flex [&:not(.showMenu)]:hidden", (optionName === "Busca" || mandatorySearch) && "showMenu"),
                        children: [
                            !mandatorySearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "absolute bottom-auto right-5 top-5 cursor-pointer border-none bg-mglGray900 text-mglGray50",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    icon: "mdi:close",
                                    width: "32",
                                    height: "32",
                                    onClick: function() {
                                        setOption("");
                                        setOpen(false);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                className: "relative ml-[20%] mr-[20%] flex justify-center px-4 py-0 text-mglGray50",
                                onSubmit: function(event) {
                                    return HandleSearchSubmit(event);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: "Buscar",
                                        className: "min-h-[50px] w-full border-0 border-b border-solid border-b-mglGray50 bg-mglGray900 text-4xl font-light text-mglGray50",
                                        type: "text",
                                        placeholder: "Buscar",
                                        onChange: function(e) {
                                            return setSearchContent(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "border-0 border-b border-solid border-mglGray50 bg-mglGray900 text-mglGray50",
                                        "aria-label": "Fechar busca",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            icon: "mdi:magnify",
                                            width: "32",
                                            height: "32"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            navbarSpan && navbarSpan.finish()
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/index.tsx



















var Layout_publicRuntimeConfig = config_default()().publicRuntimeConfig;
function Layout(param) {
    var children = param.children, layoutData = param.layoutData, _showBackgroundAd = param.showBackgroundAd, showBackgroundAd = _showBackgroundAd === void 0 ? true : _showBackgroundAd, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "span" : _headingTag, _isAdvertorial = param.isAdvertorial, isAdvertorial = _isAdvertorial === void 0 ? false : _isAdvertorial, _dataLayer = param.dataLayer, dataLayer = _dataLayer === void 0 ? undefined : _dataLayer;
    var AdsEvents = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6598).then(__webpack_require__.bind(__webpack_require__, 6598));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6598)
                ];
            }
        },
        ssr: false
    });
    var BackgroundGoogleAds = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 9216).then(__webpack_require__.bind(__webpack_require__, 9216));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(9216)
                ];
            }
        },
        ssr: false
    });
    var isAdActive = useBackground().isAdActive;
    var router = (0,next_router.useRouter)();
    var isGuiaSubdomain =  true && window.location.hostname.startsWith("guiadecompras.");
    var cleanPath = (router.asPath || router.pathname).split("?")[0].replace(/\/$/, "");
    if (isGuiaSubdomain) cleanPath = "/guia-de-compras";
    var ref = (0,useScriptsToRoute/* default */.Z)(cleanPath), useGpt = ref.useGpt, useGtm = ref.useGtm, useNavbar = ref.useNavbar, useFullScreen = ref.useFullScreen, useComscore = ref.useComscore, specifyId = ref.specifyId;
    var ref1 = layoutData || {}, segmentacoes = ref1.segmentacoes, tagsData = ref1.tagsData, navBarData = ref1.navBarData, breadcrumbList = ref1.breadcrumbList;
    var schema = layoutData === null || layoutData === void 0 ? void 0 : layoutData.schema;
    var workingList = (breadcrumbList || []).filter(function(item) {
        return item.url && item.url !== "/";
    });
    if (!schema) {
        schema = {
            breadcrumb: null,
            website: null,
            organization: null
        };
    }
    if (!schema.breadcrumb) {
        schema.breadcrumb = {
            "@context": "https://schema.org",
            "@id": "https://www.canaltech.com.br/#breadcrumb",
            "@type": "BreadcrumbList",
            itemListElement: [
                {
                    "@type": "ListItem",
                    position: 0,
                    name: "Home",
                    item: "".concat(Layout_publicRuntimeConfig.NEXT_PUBLIC_URL)
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(workingList.map(function(item, index) {
                return {
                    "@type": "ListItem",
                    position: index + 1,
                    name: item.titulo,
                    item: "".concat(Layout_publicRuntimeConfig.NEXT_PUBLIC_URL).concat(item.url)
                };
            })))
        };
    }
    if (useComscore) usePageviewConscoreRequest();
    if (useComscore) usePageviewConscoreScript();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalContainer/* default */.Z, {
        useNavbar: useNavbar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    dataLayer !== undefined && useGtm && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        id: "data-layer",
                        dangerouslySetInnerHTML: {
                            __html: "\n              window.dataLayer = window.dataLayer || [];\n\n              dataLayer.push({\n                'category': '".concat(dataLayer.category ? dataLayer.category : "", "',\n                'authorData': '").concat(dataLayer.author ? dataLayer.author : "", "',\n                'editorData': '").concat(dataLayer.editor ? dataLayer.editor : "", "',\n                'contentType': '").concat(dataLayer.contentType ? dataLayer.contentType : "", "',\n              });\n            ")
                        }
                    }),
                    useGtm && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        id: "gtm-script",
                        dangerouslySetInnerHTML: {
                            __html: "\n                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                })(window,document,'script','dataLayer', '".concat(typeof specifyId === "string" ? specifyId : Layout_publicRuntimeConfig.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID, "');\n              ")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalSchema/* ApplySchema */.BR, {
                schema: schema
            }),
            !isAdvertorial && useGpt && /*#__PURE__*/ (0,jsx_runtime.jsx)(CazambaAds, {}),
            useGpt && segmentacoes && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsEvents, {
                segmentacoes: segmentacoes
            }),
            tagsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadersPage, {
                headPage: tagsData
            }),
            useNavbar && navBarData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                navBarContent: navBarData,
                headingTag: headingTag
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {}),
            useGpt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Propaganda, {
                Ads: showBackgroundAd ? isAdActive : false,
                shouldHaveAds: !isAdvertorial
            }),
            !isAdvertorial && useGpt && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundGoogleAds, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* PageWrapper */.F, {
                ads: showBackgroundAd && useGpt ? isAdActive : false,
                fullScreen: useFullScreen,
                children: children
            }),
            !isAdvertorial && useGpt && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                type: "anchor"
            }),
            !isAdvertorial && useGpt && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                type: "Anchor_Footer"
            })
        ]
    });
}


/***/ }),

/***/ 1436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScriptFlag; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);


var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()().publicRuntimeConfig;
function useScriptFlag(param) {
    var adFlag = param.adFlag;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (publicRuntimeConfig.NEXT_PUBLIC_ENVIRONMENT === "production") return true;
    var flags = {
        google: "google",
        mgid: "mgid",
        cazamba: "cazamba"
    };
    if (flags[adFlag] in router.query) {
        if (router.query[flags[adFlag]] === "0") return false;
    }
    return true;
}


/***/ })

}]);